import React, { useState, useEffect } from 'react';
import cn from 'classnames';

import Step from 'components/nysgjerrigper/step/Step';
import Path from 'components/nysgjerrigper/path/Path';

import useResize from 'js/hooks/use-resize';

import { IStep } from 'source/NFR.types';

type Point = [number, number];
type Bezier = [number, number, number, number];

const mobilePoints: Point[] = [
  [28, 10],
  [28, 25],
  [28, 40],
  [28, 55],
  [28, 70],
  [28, 85]
];

const desktopPoints: Point[] = [
  [9, 28],
  [23, 68],
  [36, 48],
  [50, 20],
  [68, 55],
  [83, 36]
];

const desktopRelativeBeziers: Bezier[] = [
  [150, -30, -250, 0],
  [0, -250, 0, -150],
  [0, -300, -50, -75],
  [250, -50, -200, 25],
  [0, -250, -50, -100]
];

const mobileRelativeBeziers: Bezier[] = [
  [-100, 0, -78, 0],
  [51, 60, 0, -10],
  [-100, -10, -100, 30],
  [-75, -30, -80, 0],
  [30, 50, 20, -40]
];

export interface HoverData {
  mousePos?: Point;
  hoverAnimation?: boolean;
}

interface StepsMenuProps {
  menu: IStep[];
  activateStep: (index: number) => void;
  menuAnimationTrigger?: boolean;
}

const StepsMenu: React.FC<StepsMenuProps> = ({ menu, activateStep, menuAnimationTrigger }) => {
  const [isDesktop, setIsDesktop] = useState(true);
  const [isMounted, setIsMounted] = useState(false);

  const isVerticallyStyled = menu.some(step => step.isActive) || !isDesktop;

  const onResize = () => {
    setIsDesktop(window.matchMedia('(min-width: 1024px)').matches);
  };

  useResize(onResize);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const [points, relativeBeziers] = isVerticallyStyled
    ? [mobilePoints, mobileRelativeBeziers]
    : [desktopPoints, desktopRelativeBeziers];

  const [hoverData, setHoverData] = useState<HoverData>({
    mousePos: undefined,
    hoverAnimation: undefined
  });

  return (
    <div className={cn('steps-menu', { '-vertical': isVerticallyStyled })}>
      {isMounted &&
        menu?.map((step, i) => (
          <React.Fragment key={step.text}>
            <Step
              {...step}
              index={i}
              style={{ top: `${points[i][1]}%`, left: `${points[i][0]}%` }}
              setOnHoverData={setHoverData}
              isVerticallyStyled={isVerticallyStyled}
              activateStep={activateStep}
            />
            {i < menu.length - 1 && (
              <Path
                start={points[i]}
                relativeBeziers={relativeBeziers[i]}
                end={points[i + 1]}
                softAnimation={isVerticallyStyled}
                menuAnimationTrigger={menuAnimationTrigger}
                {...hoverData}
              />
            )}
          </React.Fragment>
        ))}
    </div>
  );
};

StepsMenu.displayName = 'StepsMenu';

export default StepsMenu;
